import type * as React from 'react';

/**
 * Обработчик клика по ссылке с SPA-переходом. Обычный клик отменяет переход браузера и вызывает onClick;
 * клик с модификатором (открыть в новой вкладке/окне) отдаёт браузеру.
 */
export function handleLinkClick(event: React.MouseEvent<HTMLAnchorElement>, onClick?: () => void) {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return;
  }

  event.preventDefault();
  onClick?.();
}
